import { render, staticRenderFns } from "./electricTicketDetails.vue?vue&type=template&id=1af8e6ad&scoped=true&"
import script from "./electricTicketDetails.vue?vue&type=script&lang=ts&"
export * from "./electricTicketDetails.vue?vue&type=script&lang=ts&"
import style0 from "./electricTicketDetails.vue?vue&type=style&index=0&id=1af8e6ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af8e6ad",
  null
  
)

export default component.exports